import { render, staticRenderFns } from "./infomation.vue?vue&type=template&id=666e0929&scoped=true&"
import script from "./infomation.vue?vue&type=script&lang=js&"
export * from "./infomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e0929",
  null
  
)

export default component.exports